function voirFichierTelecharger(e) {
    $.ajax({
        url: rootUrl +'file/uploaded',
        method: 'GET',
        data: {},
        success: function(data) {
            $('#panelFilesList').html(data);
        },
        error: function (xhr) {
            throw new xhr;
        }
    });
}

function uploadFiles(e) {
    console.log(e)
    $.ajax({
        url: rootUrl +'upload/files',
        method: 'GET',
        data: {},
        success: function(data) {
            $('#panelUploadFiles').html(data);
        },
        error: function (xhr) {
            throw new xhr;
        }
    });
}

function deleteFile( fileId ) {
    var verif = confirm("Voulez-vous vraiment supprimer ce fichier ?");
    if (verif) {
        $.ajax({
            type:'GET',
            url: rootUrl+'file/delete/'+fileId,
            data: { },
            async: true,
            dataType: 'text',
            contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
            beforeSend:function(xhr){
                xhr.overrideMimeType('text/html;charset=UTF-8');
            },
            success:function(data){
                document.location.href = window.location.href
            },
            error:function(xhr, textStatus, thrownError){
                alert('Erreur AJAX : '+thrownError);
            }
        });
    }
}
